<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    :is-custom-saving="loading || Boolean(currentTaskId)"
    @setPayloadValue="setPayload"
    @save="onSave"
  />
</template>
<script>
import { call, get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'IlsEasySettings',
  components: { AdminWrapper },
  computed: {
    additionalModuleName: get('admin/additionalModules@ILS_EASY_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@ils_easy_module_enabled'),
    moduleEnabler() {
      return {
        name: 'ils_easy_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },

    layers: get('layers/layers'),
    featuresLayers() {
      return this.$_objectToArray(this.layers)
        ?.filter(layer => layer.type === 'features_layer' && layer.layer_scope === 'core')
        ?.map(layer => {
          const { id, name } = layer;
          return { value: id, text: name };
        });
    },
    serviceLayers() {
      return this.$_objectToArray(this.layers)
        ?.filter(layer => layer.type === 'service_layer' && layer.layer_scope === 'core')
        ?.map(layer => {
          const { id, name } = layer;
          return { value: id, text: name };
        });
    },
    inputs() {
      const layers = [
        {
          name: 'streetLamp',
          key: 'street_lamp_id',
          type: 'features',
        },
        {
          name: 'basemapDaylight',
          key: 'basemap_daylight_id',
          type: 'service',
        },
        {
          name: 'basemapNightlight',
          key: 'basemap_nightlight_id',
          type: 'service',
        },
        {
          name: 'basemapSatellite',
          key: 'basemap_satellite_id',
          type: 'service',
        },
      ];
      return layers.map(layer => {
        return {
          name: 'ils_easy_configuration',
          valueSubproperty: layer.key,
          translationPath: `admin.ilsEasy.${layer.name}`,
          rules: [v => !!v || v === 0 || 'rules.required'],
          dataType: {
            name: 'select',
          },
          items: this[`${layer.type}Layers`],
          isCustom: true,
        };
      });
    },
  },
  data: () => ({
    currentTaskId: null,
    isFormFetched: false,
    loading: false,
    payload: {},
  }),
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    ilsEasySync: call('admin/ilsEasySync'),
    getLayers: call('layers/getLayers'),
    setPayload({ value, subproperty }) {
      this.payload = { ...this.payload, [subproperty]: value };
    },
    async onSave() {
      this.loading = true;
      try {
        await this.editSingleSetting({
          key: 'ils_easy_configuration',
          body: { value: this.payload },
        });
        this.currentTaskId = await this.ilsEasySync();
        this.$globalHub.$emit('handleCeleryTask', {
          skipTaskResult: true,
          currentTaskId: this.currentTaskId,
          taskStartSnackbar: {
            message: this.$i18n.t('snackbar.ilsEasy'),
          },
          taskFailureSnackbar: {
            message: this.$i18n.t('snackbar.ilsEasyError'),
          },
          taskFailureCallback: this.endSave,
          taskSuccessCallback: () => {
            this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
              message: this.$i18n.t('snackbar.ilsEasyCompleted'),
            });
            this.endSave();
          },
        });
      } catch {
        this.endSave();
      } finally {
        this.loading = false;
      }
    },
    endSave() {
      this.loading = false;
      this.currentTaskId = null;
    },
    async init() {
      this.isFormFetched = false;
      await this.getLayers();
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
